import { KeyValue } from '@/main/models/common';

export enum PreQuoteTypeTypes {
  GET_PRE_QUOTE_TYPE = '@preQuoteType/GET_PRE_QUOTE_TYPE',
  SAVE_PRE_QUOTE_TYPE = '@preQuoteType/SAVE_PRE_QUOTE_TYPE',
  RESET_REDUCER_PRE_QUOTE_TYPE = '@preQuoteType/RESET_REDUCER_PRE_QUOTE_TYPE',
  GET_DOMAIN_PRE_QUOTE_TYPE_STATUS = '@quoteStatus/GET_DOMAIN_PRE_QUOTE_TYPE_STATUS'
}

export interface PreQuoteTypeState {
  readonly preQuoteType: {
    data:  KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetPreQuoteType {
  type: typeof PreQuoteTypeTypes.GET_PRE_QUOTE_TYPE;
}

export interface SavePreQuoteType {
  type: typeof PreQuoteTypeTypes.SAVE_PRE_QUOTE_TYPE;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerPreQuoteType {
  type: typeof PreQuoteTypeTypes.RESET_REDUCER_PRE_QUOTE_TYPE;
}

export interface GetDomainPreQuoteTypeStatus {
  type: typeof PreQuoteTypeTypes.GET_DOMAIN_PRE_QUOTE_TYPE_STATUS;
  payload: {
    keyReducer: string;
  }
}

export type PreQuoteTypeActionTypes =
  | GetPreQuoteType
  | SavePreQuoteType
  | ResetReducerPreQuoteType
  | GetDomainPreQuoteTypeStatus;
